<div class="container-fluid">
  <div class="row section1">
    <div class="col-12 col-md-7 col-lg-7 col-xl-7">
      <div class="home-details">
        <h5 class="home-title">Reviews</h5>
        <p class="home-subtitle">List of all Reviews</p>
      </div>
    </div>
    <div class="col-12 col-md-7 col-lg-5 col-xl-5">
      <div class="dashboard-btn dashboard-manage">
        <!-- <div> <a href="#"><button class="btn btn-primary btn-deshboard">Export list</button></a></div> -->
        <div class="filter-row filter-row1">
          <div class="form-label show">filter by :</div>
          <div class="select-wrapper-sm">
            <select class="form-control border-0 input-sm">
              @for (rv of reviews; track rv; let rvi = $index) {
                <option >{{rv.name}}</option>
              }
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-----------user table------------------>
  <div class="row section1">
    <div class="col-12">
      <div class="table-responsive applicants-details overflow-x-visible">
        <table class="table table-bordered user-table">
          <thead>
            <tr>
              <!--            <th scope="col">Entities</th>-->
              <!--            <th scope="col">Entity Name</th>-->
              <!--            <th scope="col">Category</th>-->
              <th scope="col">User</th>
              <th scope="col">User ID</th>
              <th scope="col">Ratings</th>
              <th scope="col">Reviews</th>
              <th scope="col">Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (cr of currentRatings; track cr; let cri = $index) {
              <tr class="client">
                <!--            <td>{{ r.category.categoryName }}</td>-->
                <!--            <td>{{ r.entity.entityName }}</td>-->
                <!--            <td>{{ r.parameter.fieldName }}</td>-->
                <td>{{ cr.user.fullName }}</td>
                <td>{{ cr.user.id }}</td>
                <td width="120">
                  <li style="color: orange">Hindu : {{cr.value[0].score}}</li>
                  <li style="color: blue">Christian : {{cr.value[1].score}}</li>
                  <li style="color: green">Muslim : {{cr.value[2].score}}</li>
                </td>
                <td>{{ cr.message }}</td>
                <td class="action">
                  <div class="dropdown">
                    <button type="button" class="btn header-item waves-effect" id="page-header-user-dropdown"
                      data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
                      <i class="las la-angle-down"></i>
                    </button>
                    <div class="dropdown-menu dropdown-menu-right animate slideIn">
                      <a class="dropdown-item">
                        <i class="las la-eye font-size-16 align-middle mr-1"></i>
                      View</a>
                      <!-- <a class="dropdown-item" [routerLink]="['/edit-entity/', user.id]"><i
                    class="las la-edit font-size-16 align-middle mr-1"></i>
                  Edit</a>-->
                  <a class="dropdown-item" (click)="remove(cr.id, cri)"><i
                  class="las la-trash font-size-16 align-middle mr-1"></i>
                Delete</a>
              </div>
            </div>
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
</div>
</div>
</div>
